import React from 'react';

import './catalog-item.css';

const CatalogItem = ({
  id,
  title,
  price,
  mainImage,
  images = [],
  bottomChildren,
  alt,
  onClick = () => {},
}) => {
  return (
    <div className='catalog__item'>
      <div className='catalog__item__top'>
        <div className='catalog__item__top-info'>
          <img src={mainImage || (images[0] || {}).original} alt={alt || title} />
          <div>
            <div className='catalog__item__top-title'>{title}</div>
            <div className='catalog__item__top-number'>
              <span>Номер лота:</span>
              &nbsp;
              <span className='catalog__item__top-number__id'>{id}</span>
            </div>
          </div>
        </div>
        <div className='catalog__item__top__price'>
          <span className='catalog__item__top__price-text'>Ціна:</span>
          &nbsp;
          <span className='catalog__item__top__price-number'>{price}</span>
        </div>
      </div>
      <div className='catalog__item__bottom'>
        {bottomChildren || (
          <div className='catalog__item__bottom__buy-button' onClick={onClick}>
            Купити
          </div>
        )}
      </div>
    </div>
  );
};

export default CatalogItem;
